import { useState } from 'react';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <nav className="bg-white shadow-md fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/3294a4af19582454411e375cbd1c78be/494c4a1b567184a65b3f02374d4f7977.jpeg" 
              alt="Logo Madrasah Tahfiz Al Quran Zawiyah Darul Madad" 
              className="h-14 w-auto"
            />
            <div className="hidden md:block">
              <h1 className="text-lg font-bold text-emerald-800">Madrasah Tahfiz Al Quran</h1>
              <p className="text-sm text-emerald-700">Zawiyah Darul Madad</p>
            </div>
          </div>

          <div className="hidden lg:flex items-center gap-8">
            <button onClick={() => scrollToSection('utama')} className="text-gray-700 hover:text-emerald-700 transition-colors cursor-pointer whitespace-nowrap">Utama</button>
            <button onClick={() => scrollToSection('profil')} className="text-gray-700 hover:text-emerald-700 transition-colors cursor-pointer whitespace-nowrap">Profil</button>
            <button onClick={() => scrollToSection('program')} className="text-gray-700 hover:text-emerald-700 transition-colors cursor-pointer whitespace-nowrap">Program</button>
            <button onClick={() => scrollToSection('kemasukan')} className="text-gray-700 hover:text-emerald-700 transition-colors cursor-pointer whitespace-nowrap">Kemasukan</button>
            <button onClick={() => scrollToSection('infaq')} className="text-gray-700 hover:text-emerald-700 transition-colors cursor-pointer whitespace-nowrap">Infaq</button>
            <button onClick={() => scrollToSection('galeri')} className="text-gray-700 hover:text-emerald-700 transition-colors cursor-pointer whitespace-nowrap">Galeri</button>
            <button onClick={() => scrollToSection('hubungi')} className="bg-emerald-700 text-white px-6 py-2 rounded-full hover:bg-emerald-800 transition-colors cursor-pointer whitespace-nowrap">Hubungi Kami</button>
          </div>

          <button 
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer"
          >
            <i className={`ri-${isOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="lg:hidden bg-white border-t">
          <div className="px-4 py-4 space-y-3">
            <button onClick={() => scrollToSection('utama')} className="block w-full text-left py-2 text-gray-700 hover:text-emerald-700 cursor-pointer">Utama</button>
            <button onClick={() => scrollToSection('profil')} className="block w-full text-left py-2 text-gray-700 hover:text-emerald-700 cursor-pointer">Profil</button>
            <button onClick={() => scrollToSection('program')} className="block w-full text-left py-2 text-gray-700 hover:text-emerald-700 cursor-pointer">Program</button>
            <button onClick={() => scrollToSection('kemasukan')} className="block w-full text-left py-2 text-gray-700 hover:text-emerald-700 cursor-pointer">Kemasukan</button>
            <button onClick={() => scrollToSection('infaq')} className="block w-full text-left py-2 text-gray-700 hover:text-emerald-700 cursor-pointer">Infaq</button>
            <button onClick={() => scrollToSection('galeri')} className="block w-full text-left py-2 text-gray-700 hover:text-emerald-700 cursor-pointer">Galeri</button>
            <button onClick={() => scrollToSection('hubungi')} className="block w-full text-left py-2 bg-emerald-700 text-white rounded-lg hover:bg-emerald-800 cursor-pointer">Hubungi Kami</button>
          </div>
        </div>
      )}
    </nav>
  );
}
